import { isPlainObject } from "lodash";
let url_not_be_null = "url不允许为空";
let server_error = "Server error";

const responseResult = (response, resolve, reject) => {
    try {
        let code = response.resultCode || (response.rc == 0 ? '0' : response.rc) || response.status;
        code = typeof code === 'undefined' ? response.ret : code; // 风控接口
        let msg = response.resultMsg || response.msg || response.massage;
        let t = response.t ? response.t : (response.result ? response.result : response.data ? response.data : response.items);
        let resps = response;

        switch (code.toString()) {
            case "701":
                return reject(response);
            case "0":
                return resolve({ code, t, msg, resps });
            case "200":
                return resolve({ code, t, msg });
            case "00000":
                return resolve({ code, t, msg });
            default:
                return reject({ code, t, msg });
        }
    }
    catch (e) {
        console.log('http error catch==>>>', e)
    }
}

const JsonToSearchParams = (params) => {
    if (isPlainObject(params)) {
        const formData = new URLSearchParams();
        for (let key in params) {
            let value = params[key];
            formData.append(key, value);
        }
        return formData;
    } else {
        throw new Error("the param is a plain Object");
    }
}

let Ajax = {
    jsonp(url, callbackKey, jsonpCallbackKey, data = null) {
        if (!url) {
            return Promise.reject({ data: null, msg: url_not_be_null });
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'get',
                url: url,
                dataType: "jsonp",
                jsonp: callbackKey,
                jsonpCallback: jsonpCallbackKey,
                timeout: 5000,
                data: data,
                // xhrFields: {
                //     withCredentials: true
                // },
                success: function (res) {
                    responseResult(res, resolve, reject);
                },
                error: function (err) {
                    reject({ data: null, msg: server_error });
                }
            })
        })
    },
    get(url, opts) {
        if (!url) {
            return Promise.reject({ data: null, msg: url_not_be_null });
        }
        if (url.indexOf("?") == url.length - 1) {
            url += "&ran=" + Math.random();
        } else {
            url += "?ran=" + Math.random();
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type: "get",
                contentType: 'application/json',
                dataType: "json",
                data: opts,
                success: function (res) {
                    responseResult(res, resolve, reject);
                },
                error: function (error) {
                    return Promise.reject({ data: null, msg: server_error });
                }
            });
        });
    },
    postFormData(url, params = {}) {
        // const formData = JsonToSearchParams(params);    
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type: "post",
                // contentType: 'application/json; charset=UTF-8',
                data: params,
                // xhrFields: {
                //     withCredentials: true
                // },
                success(res) {
                    responseResult(res, resolve, reject);
                },
                error: function (err) {
                    return Promise.reject({ data: null, msg: server_error });
                }
            });
        })
    },
    post(url, data, opts = {}) {
        if (!url) {
            return Promise.reject({ data: null, msg: url_not_be_null });
        }
        return new Promise((resolve, reject) => {
            let defaultParams = {
                url: url,
                type: "post",
                // contentType: 'application/json; charset=UTF-8',
                data: data,
                dataType: "json",
                xhrFields: {
                    withCredentials: true
                },
            }

            let params = Object.assign(defaultParams, opts);
            $.ajax({
                ...params,
                success(res) {
                    responseResult(res, resolve, reject);
                },
                error: function (err) {
                    return Promise.reject({ data: null, msg: server_error });
                }
            });
        })
    },
    upload(url, formData) {
        if (!url) {
            return Promise.reject({ data: null, msg: url_not_be_null });
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                type: "post",
                data: formData,
                contentType: false,
                processData: false,
                // contentType:"multipart/form-data",
                dataType: "json",
                success: function (res) {
                    responseResult(res, resolve, reject);
                },
                error: function (err) {
                    return Promise.reject({ data: null, msg: server_error });
                }
            });
        })
    },
    all(promises) {
        return Promise.all(promises);
    }
}

export default Ajax;